import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-email-dialog',
  standalone: false,
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss'],
})
export class EmailDialogComponent {
  readonly dialogRef = inject(MatDialogRef<EmailDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA)

  close() {
    window.location.href = '/landing';
  }
}
